// RITA-1498 (Nutzungserfassung Phase 1b) — Oberflächenfehler abfangen (Konzept 3.5, 4.1 Punkt 4).
// Nur Zuhörer, kein Ersatz von window.onerror: der Browser-Standardablauf bleibt unberührt.
export type CapturedErrorSource = 'window' | 'promise';
export type ErrorReporter = (source: CapturedErrorSource, error: unknown) => void;

export interface ErrorWindowLike {
  addEventListener(type: string, listener: (event: Event) => void): void;
  removeEventListener(type: string, listener: (event: Event) => void): void;
}

const UNKNOWN = 'unbekannter Fehler';

export const installErrorCapture = (win: ErrorWindowLike, report: ErrorReporter): (() => void) => {
  const onError = (event: Event): void => {
    const { error, message } = event as ErrorEvent;
    try {
      report('window', error ?? { message: message || UNKNOWN });
    } catch {
      // nie den Standardablauf stören
    }
  };
  const onRejection = (event: Event): void => {
    const { reason } = event as { reason?: unknown };
    try {
      report('promise', reason ?? { message: UNKNOWN });
    } catch {
      // siehe oben
    }
  };
  win.addEventListener('error', onError);
  win.addEventListener('unhandledrejection', onRejection);
  return () => {
    win.removeEventListener('error', onError);
    win.removeEventListener('unhandledrejection', onRejection);
  };
};

export default installErrorCapture;
